import { NoonReportScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Noon Report (ortak ekran; ADR 0022). Ofiste salt okunur: rapor gemide girilir. */
export function NoonReportPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.noon.title')}>
      <NoonReportScreen source={officeVoyageSource} />
    </Shell>
  );
}
